import { Input, type InputProps } from "@/components/base/input/input";
import { Label } from "@/components/base/input/label";
import { useFieldContext } from "..";
import { FieldErrors } from "./FieldErrors";

interface TextFieldProps extends InputProps {
	label?: string;
	field?: any; // Simplified for now - will be properly typed later
}

const TextField = ({ field: fieldProp, ...props }: TextFieldProps) => {
	// Support both patterns:
	// 1. form.Field with explicit field prop
	// 2. form.AppField with useFieldContext
	const contextField = useFieldContext<string>();
	const field = fieldProp || contextField;

	return (
		<div className="space-y-2">
			<div className="space-y-1">
				<Label htmlFor={field.name}>{props.label}</Label>
				<Input
					{...props}
					id={field.name}
					label={props.label}
					value={field.state.value}
					onChange={field.handleChange}
					onBlur={field.handleBlur}
					isInvalid={field.state.meta.isTouched && !field.state.meta.isValid}
					isDisabled={props.isDisabled || field.state.meta.isValidating}
					isRequired={field.state.meta.isRequired}
				/>
			</div>
			<FieldErrors meta={field.state.meta} />
		</div>
	);
};

export default TextField;
